import React, { InputHTMLAttributes } from 'react';
import { useInputField } from '~/shared/utils';
import {
    StyledCheckboxWrapper,
    StyledCheckboxElement,
    StyledCheckbox,
    StyledCheckboxIndicator,
    StyledLabel,
    StyledCheckboxHelpTexts,
    StyledCheckboxIcon,
} from './style';
import { controllableInputElementsProps } from '~/shared/components/form';
import { StyledInvalidMessage } from '../../invalid-message';
import { StyledHelpText } from '../../help-text';
import { useController, useFormContext } from 'react-hook-form';

export type CheckboxElementProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'placeholder'> &
    controllableInputElementsProps & {
        /**
         * In case you wanna do your own
         */
        hideInvalidMessage?: boolean;

        /**
         * Toggle between checkbox or radio
         */
        type?: 'checkbox' | 'radio';
        title?: string;
        name: string;
    };

export const CheckboxElement = ({
    name,
    label,
    helpText,
    title,
    isInvalid,
    invalidMessage,
    id,
    type = 'checkbox',
    hideInvalidMessage,
    ...rest
}: CheckboxElementProps) => {
    const { control } = useFormContext();
    const {
        field: { onChange, value, onBlur },
        fieldState: { invalid },
    } = useController({
        name,
        control,
        // defaultValue,
    });

    const { fieldId, helpTextId, describedById, showHelpText } = useInputField({
        id,
        helpText,
        isInvalid,
        invalidMessage,
    });

    return (
        <div key={fieldId}>
            <StyledCheckboxWrapper round={type === 'radio'} valid={!invalid}>
                <StyledCheckboxElement disabled={rest.disabled} round={type === 'radio'}>
                    <StyledCheckbox
                        type={type}
                        onChange={onChange}
                        onBlur={onBlur}
                        id={fieldId}
                        aria-describedby={describedById}
                        checked={value}
                        {...rest}
                    />
                    <StyledCheckboxIndicator round={type === 'radio'} />
                    <StyledCheckboxIcon color="white" size={12} />
                </StyledCheckboxElement>

                {label ? (
                    <StyledLabel
                        title={title}
                        disabled={rest.disabled}
                        htmlFor={fieldId}
                        children={label}
                    />
                ) : null}
            </StyledCheckboxWrapper>

            <StyledCheckboxHelpTexts>
                {invalidMessage && !hideInvalidMessage ? (
                    <StyledInvalidMessage children={invalidMessage} />
                ) : null}

                {showHelpText ? <StyledHelpText id={helpTextId} children={helpText} /> : null}
            </StyledCheckboxHelpTexts>
        </div>
    );
};

export default CheckboxElement;
